exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card { \n  margin-bottom: 30px;\n}\n\n.card-img-top { \n  height: 200px;\n}\n\n.card-footer {\n  padding: 0;\n  background: #fff;\n}\n\n.card-footer button {\n  cursor: pointer;\n  text-transform: uppercase;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/shared/components/product-card/product-card.component.css
// module id = ../../../../../src/app/shared/components/product-card/product-card.component.css
// module chunks = main